import axios from '@/utils/axios'

const rootUrl = 'masterdata/website/goods/'
const api = {
  AddGoods: rootUrl + 'addGoods',
  ModifyGoods: rootUrl + 'modifyGoods',
  GetPage: rootUrl + 'getPage',
  Getlist: rootUrl + 'getlist',
  GetDetail: rootUrl + 'getDetail',
  GetListByClientId: rootUrl + 'getListByClientId',
  GetCategoriesList: rootUrl + 'getCategoriesList',
  AddGoodsCategories: rootUrl + 'addGoodsCategories',
  EditGoodsCategories: rootUrl + 'editGoodsCategories',
  DelGoodsCategories: rootUrl + 'delGoodsCategories',
  AddGoodsToCategories: rootUrl + 'addGoodsToCategories',
  GetGoodsByCategories: rootUrl + 'getGoodsByCategories',
  GetGoodsList: rootUrl + 'getGoodsList',
  chooseGoodsList: 'masterdata/website/hospital/chooseGoodsList',
  DelGoods: rootUrl + 'delGoods',
  GetListByCategories: rootUrl + 'getListByCategories',
  GetGoodsPage: rootUrl + 'getGoodsPage',
  GetListByName: rootUrl + 'getListByName',
  SetGoodsSort: rootUrl + 'setGoodsSort',
  bahealGoodsResourceList: rootUrl + 'bahealGoodsResourceList',
  bahealGoodsResourceSyncToGoods: rootUrl + 'bahealGoodsResourceSyncToGoods',
  removeBahealGoodsResource: rootUrl + 'removeBahealGoodsResource'
}

/**
 * 添加产品接口
 * goods_name, goods_list
 */
export function addGoods (parameter) {
  return axios.formRequest.post(api.AddGoods, parameter)
}

/**
 * 编辑产品接口
 * goods_name, goods_list, goods_del
 */
export function modifyGoods (parameter) {
  return axios.formRequest.post(api.ModifyGoods, parameter)
}

/**
 * 产品列表接口(分页) page, categories_id, search_text
 */
export function getPage (parameter) {
  return axios.formRequest.post(api.GetPage, parameter)
}
/**
 * 产品列表接口(不分页)
 */
export function getListByName (parameter) {
  return axios.formRequest.post(api.GetListByName, parameter)
}
/**
 * 产品列表接口排序
 */
export function setGoodsSort (parameter) {
  return axios.formRequest.post(api.SetGoodsSort, parameter)
}
/**
 * 物料列表
 */
export function bahealGoodsResourceList (parameter) {
  return axios.formRequest.post(api.bahealGoodsResourceList, parameter)
}
/**
 * 标为业务品规
 * @param {*} parameter
 * @returns
 */
export function bahealGoodsResourceSyncToGoods (parameter) {
  return axios.formRequest.post(api.bahealGoodsResourceSyncToGoods, parameter)
}
/**
 * 取消业务品规
 * @param {*} parameter
 * @returns
 */
export function removeBahealGoodsResource (parameter) {
  return axios.formRequest.post(api.removeBahealGoodsResource, parameter)
}
/**
 * 产品列表接口(有品规)
 * has_categories 0-所有 1-有分类
 */
export function getlist (name, has_categories = 0) {
  return axios.formRequest.post(api.Getlist, {
    name,
    has_categories
  })
}

/**
 * 产品列表接口 账号限制
 */
export function getGoodsList (name, client_id, categories_id, scene, is_all, goods_label_ids, is_template) {
  return axios.formRequest.post(api.GetGoodsList, {
    name,
    client_id,
    categories_id,
    scene,
    is_all,
    goods_label_ids: goods_label_ids,
    is_template //仅 behaviorManage/data-report-setting/add 页面 判断提示语用
  })
}

export function getGoodsConvertSetting (parameter) {
  return axios.formRequest.post("flow/website/stats/getGoodsConvertSetting", parameter)
}

/**
 * 产品列表接口 按品种定级 不设置问卷 编辑医生时调用
 */
export function chooseGoodsList (name) {
  return axios.formRequest.post(api.chooseGoodsList, {
    name
  })
}

/**
 * 产品详情接口
 */
export function getDetail (goods_name, categories_id) {
  return axios.formRequest.post(api.GetDetail, {
    goods_name,
    categories_id
  })
}
/**
 * 产品详情接口
 */
export function getDetailTwo (parameter) {
  return axios.formRequest.post(api.GetDetail, parameter)
}

/**
 * 产品详情接口
 */
export function getListByClientId (clientId, name) {
  return axios.formRequest.post(api.GetListByClientId, {
    clientId,
    name,
  })
}

/**
 * 获取产品分类
 */
export function getCategoriesList (parent_id) {
  return axios.formRequest.post(api.GetCategoriesList, {
    parent_id
  })
}
/**
 * 获取产品分类
 */
export function getCategoriesListTwo (parent_id) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/getCategoriesList', {
    parent_id
  },
  )
}


/**
 * 添加产品分类
 */
export function addGoodsCategories (name, parentId) {
  return axios.formRequest.post(api.AddGoodsCategories, {
    name,
    parentId
  })
}

/**
 * 编辑产品分类
 */
export function editGoodsCategories (name, categoriesId) {
  return axios.formRequest.post(api.EditGoodsCategories, {
    name,
    categoriesId,
  })
}

/**
 * 删除产品分类
 */
export function delGoodsCategories (categories_id) {
  return axios.formRequest.post(api.DelGoodsCategories, {
    categories_id
  })
}

/**
 * 分类下添加产品
 */
export function addGoodsToCategories (goods_ids, categoriesId) {
  return axios.formRequest.post(api.AddGoodsToCategories, {
    goods_ids,
    categoriesId,
  })
}

/**
 * 分类能看到的产品
 */
export function getGoodsByCategories (categoriesId) {
  return axios.formRequest.post(api.GetGoodsByCategories, {
    categoriesId
  })
}

/**
 * 删除产品
 */
export function delGoods (params) {
  return axios.formRequest.post(api.DelGoods, params)
}

/**
 * 根据分类获取产品接口
 */
export function getListByCategories (
  search_text,
  categories_id,
  goods_label_ids,
) {
  return axios.formRequest.post(api.GetListByCategories, {
    search_text,
    categories_id,
    goods_label_ids,
  })
}

/**
 * 产品品规(分页) page, search_text
 */
export function getGoodsPage (parameter) {
  return axios.formRequest.post(api.GetGoodsPage, parameter)
}

/**
 * 产品分类列表
 */
export function chooseCategoriesByConfig (find_value, categories_id) {
  return axios.formRequest.post(
    '/masterdata/website/goods/chooseCategoriesByConfig', {
    find_value,
    categories_id
  },
  )
}

/**
 * 品种列表
 */
export function goodsList () {
  return axios.formRequest.post('/masterdata/website/goods/varietiesList', {})
}

/**
 * 品名列表
 */
export function getGoodsNameList (search_text, categories_id) {
  return axios.formRequest.post('masterdata/website/goods/getGoodsNameList', {
    search_text,
    categories_id,
  })
}

/**
 * 获取产品分类
 */
export function getGoodsCategories (level) {
  return axios.formRequest.post('masterdata/website/goods/getGoodsCategories', {
    level,
  })
}

/**
 * 获取产品种
 */
export function getGoodsVarietiesList (name) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsVarietiesList', {
    name
  },
  )
}

/**
 * 获取产品分类
 */
export function getCategoriesListByQuarter (parent_id) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/getCategoriesListByQuarter', {
    parent_id
  },
  )
}

/**
 * 获取产品
 */
export function getGoodsNameListSaleindex () {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/getGoodsNameList', {},
  )
}

/**
 * 获取分类---简称
 */
export function getWebCategoriesList () {
  return axios.formRequest.post(
    'masterdata/website/goods/getWebCategoriesList', {},
  )
}

/**
 * 流向申诉获取分类
 */
export function getFlowWebCategoriesList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getWebCategoriesList',
    parameter,
  )
}

/**
 *  获取OA全部涉及产品
 */
export function getGoodsListOA (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsList',
    parameter,
  )
}

/**
 * 产品自定义字段列表
 */
export function goodsCustomFieldList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_custom/fieldList',
    parameter,
  )
}

/**
 * 添加产品自定义字段
 */
export function goodsCustomDelField (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_custom/delField',
    parameter,
  )
}

/**
 * 添加产品自定义字段
 */
export function goodsCustomAddField (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_custom/addField',
    parameter,
  )
}

/**
 * 编辑产品自定义字段
 */
export function goodsCustomEditField (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_custom/editField',
    parameter,
  )
}

/**
 * 产品自定义字段详情
 */
export function goodsCustomFieldDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_custom/fieldDetail',
    parameter,
  )
}

/**
 * 产品标签列表(不分页)
 */
export function getGoodsTagList (type) {
  return axios.formRequest.get(
    'masterdata/website/goods_label/getList?status=' + type,
  )
}

/**
 * 产品标签批量保存
 */
export function batchSave (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_label/batchSave',
    parameter,
  )
}

/**
 * 检测标签是否被使用
 */
export function checkGoodsLabel (parameter) {
  return axios.formRequest.get(
    `masterdata/website/goods_label/checkGoodsLabel?goods_label_ids=${parameter}`,
  )
}

/**
 * 通过等级获取产品分类
 */
export function getCategoriesListByLevel (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getCategoriesListByLevel',
    parameter,
  )
}

/**
 * 页面添加医生负责人  选择产品
 */
export function getClientGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getClientGoods',
    parameter,
  )
}

/**
 * 主规格列表
 */
export function mainGoodsList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/mainGoodsList',
    parameter,
  )
}


/**
 * 选择品种列表
 */
export function getQuestionGoodsList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_question_level/getQuestionGoodsList',
    parameter,
  )
}

/**
 * 获取产品下拉列表
 */
export function getGoodsListForSelect (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsListForSelect',
    parameter,
  )
}

/**
 * 获取产品表头
 */
export function getGoodsTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsTitle',
    parameter,
  )
}

/**
 * 设置产品表头
 */
export function setGoodsTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/setGoodsTitle',
    parameter,
  )
}


/**
 * 集采产品列表
 */
export function getCollectiveGoodsList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getCollectiveGoodsList',
    parameter,
  )
}

/**
 * 非集采产品列表
 */
export function getNoCollectiveGoodsList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getNoCollectiveGoodsList',
    parameter,
  )
}

/**
 * 删除集采产品列表
 */
export function delCollectiveGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/delCollectiveGoods',
    parameter,
  )
}

/**
 * 集采产品详情
 */
export function getCollectiveGoodsDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getCollectiveGoodsDetail',
    parameter,
  )
}


/**
 * 添加/编辑集采产品接口
 */
export function addCollectiveGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/addCollectiveGoods',
    parameter,
  )
}

/**
 * 按照查看方式获取产品
 */
export function getCollectiveGoods (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_goods_total/getCollectiveGoods',
    parameter,
  )
}

/**
 * 产品列表
 */
export function getGoodsDataList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsDataList',
    parameter,
  )
}
